var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-icon"},[_c('i',{staticClass:"bqh bqh-geren_2",style:([{fontSize:_vm.size+'px'},{padding:_vm.center?'0.5em':'0.9rem 0.5rem 0 0.5rem'}])})])
}
var staticRenderFns = []

export { render, staticRenderFns }